import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from 'axios';
import {token, domain} from './../Security';
import {CreateTableForEmployeeSelect} from './../ManageTable';
import loadingSpinner from './../../assets/loading.gif';
import {useTable} from 'react-table';
import {globalTimeFormat} from './../Security';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UploadIcon from '@mui/icons-material/Upload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

function Overtime({user, userAccess, isHideSideMenu}) {
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [employee, setEmployee] = useState(
    user.employeePersonalInformationFullName
    );
    const [employeeId, setEmployeeId] = useState(
        user.employeePersonalInformationId
    );
    const [overtimeType, setOvertimeType] = useState("");
    const [date, setDate] = useState("");
    const [hours, setHours] = useState("");
    const [hasOvertimeAllowance, setHasOvertimeAllowance] = useState(false);
    const [isAboveTwoHoursOvertime, setIsAboveTwoHoursOvertime] = useState(false);
    const [isOTStraightWithoutBreak, setIsOTStraightWithoutBreak] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    const [reason, setReason] = useState("");
    const [files, setFiles] = useState([]);
    const [gpsCam, setGPSCam] = useState([]);

    const [showVieHistoryForm, setShowVieHistoryForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const overtimeUrl =  domain + "/api/OvertimeRequest";

    const [dtrData, setDTRData] = useState([]);
    const [currentDate, setCurrentDate] = useState("");
    const fetchData = useCallback(async () => {
        if (!date && overtimeType !== "Regular") {
        return;
        }

        setLoadingRequest(true);

        const data = {
        dateFrom: date,
        dateTo: date,
        employeePersonalInformationId: employeeId ? employeeId : 0,
        };

        try {
        const response = await axios.post(overtimeUrl + "/user-overtime", data, {
            headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            },
        });

        setDTRData(response.data);
        } catch (error) {
        setLoadingRequest(false);
        setShowRequestMessage(true);
        setIsSuccess(false);
        console.error("Error:", error);
        const errorMessage = JSON.parse(
            error.response.request.responseText
        ).message;
        setRequestMessage(errorMessage);
        } finally {
        setLoadingRequest(false);
        }
    }, [date, overtimeUrl, employeeId, overtimeType]);

    useEffect(() => {
        if (!date) return;

        const parts = date.split("-");
        const year = parts[0];

        const yearNum = Number(year);

        if (
            year &&
            year.length === 4 &&
            yearNum >= 1900 &&
            yearNum <= 2099 &&
            currentDate !== date
        ) {
            setCurrentDate(date);
            fetchData();
        }
    }, [date, currentDate, fetchData]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!employee || 
            !overtimeType ||
            !date ||
            !hours
            ) {
            alert("Required to fill up all data");
            return; // Exit early if fields are empty
        }

        if (overtimeType === "Regular") {
            if (hours > dtrData[0]?.otHours || dtrData.length <= 0) {
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(
                "You cannot file OT that exceeds your rendered time."
                );
                return;
            }
        }

        const getFormattedDate = () => {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}T00:00`;
            return formattedDate;
        };

        const toBase64 = (file) => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    
        //CONTEXT
        let base64String = "";
        let photoToBeSave = "";
    
        if(files.length > 0){
            base64String = await toBase64(files[0]);
            photoToBeSave = base64String.split(',')[1];
        }

        const uploadImage = files ? photoToBeSave : null;

        //GPS CAM
        let base64StringGPSCam = "";
        let photoToBeSaveGPSCam = "";
    
        if(gpsCam.length > 0){
            base64StringGPSCam = await toBase64(gpsCam[0]);
            photoToBeSaveGPSCam = base64StringGPSCam.split(',')[1];
        }

        const _gpsCam = gpsCam ? photoToBeSaveGPSCam : null;

        const data = {
            employeePersonalInformationId: employeeId,
            approverId: null,
            requestTypeId: 3, // 3 is Overtime Request
            reason: reason,
            reasonForRejection: null,
            status: "Sent",
            dateRequested: getFormattedDate(),
            dateCompleted: getFormattedDate(),
            content: uploadImage,
            gpsCam: _gpsCam,
            date: date,
            hours: hours,
            originalHours: hours,
            overtimeType: overtimeType,
            hasOvertimeAllowance: hasOvertimeAllowance,
            isAboveTwoHoursOvertime: isAboveTwoHoursOvertime
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            const response = await axios.post(overtimeUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await sendSms(response.data);
            await createApproval(response.data)

            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Data added successfully');

            // Reload table data and reset form fields
            setOvertimeType("");
            setDate("");
            setHours("");
            setHasOvertimeAllowance(false);
            setIsAboveTwoHoursOvertime(false);
            setIsOTStraightWithoutBreak(false);
            setReason("");
            setFiles("");
            setGPSCam("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const createApproval = async (dataToAdd) => {
        const apiUrl =  domain + "/api/Approval";

        const data = {
            requestId: dataToAdd.id,
            requestTypeId: dataToAdd.requestTypeId,
            primaryApproverId: null,
            primaryApproverUpdateDate: null,
            primaryApproverStatus: "Pending",
            secondaryApproverId: null,
            secondaryApproverUpdateDate: null,
            secondaryApproverStatus: "Pending",
            tertiaryApproverId: null,
            tertiaryApproverUpdateDate: null,
            tertiaryApproverStatus: "Pending",
        };

        try {
            await axios.post(apiUrl + `/${0}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log("create approval success")
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }
    const closeUploadFormHandleClick = () => {
        setShowUploadForm(false);
    }
    const handleFileUpload = () => {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("This is undermaintenance");
    }

    const [errorState, setErrorState] = useState(false);
    /* const [maximumOTHours, setMaximumOTHours] = useState("");

    const fetchDataEmployee = useCallback(async () => {
        const apiUrl = domain +"/api/Employee/";

        try {
            const response = await axios.get(apiUrl + user.employeePersonalInformationId, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);

    const getMaximumNoOfOTHours = useCallback(async () => {
        const apiUrl = domain +"/api/OvertimeRequest/overtime";
        const employeeInfo = await fetchDataEmployee();

        const data = {
            date: date,
            employeeId: employeeInfo.employeeId,
        };

        try {
            const response = await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            console.log(response.data)
            return response.data.overtimeInHours;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [date, fetchDataEmployee]);

    useEffect(() => {
        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };
        
        if(date && overtimeType){
            const fetchOTHours = async () => {
                const noOfHours = await getMaximumNoOfOTHours();

                if(noOfHours === "" || noOfHours === undefined || noOfHours === null){
                    setMaximumOTHours(0);
                } else {
                    setMaximumOTHours(numberWithCommasAndDecimal(parseFloat(noOfHours)));
                }
            }

            fetchOTHours();
        }
    }, [date, overtimeType, getMaximumNoOfOTHours]) */

    const submit = (e) =>{
        if (!employee || 
            !overtimeType ||
            !date ||
            !hours
            ) {
            setErrorState(true);
            return;
        }

        if(files.length === 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Attached proof of approval is required.");

            return;
        }

        if(gpsCam.length === 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("GPS Cam attachment is required.");

            return;
        }

        /* if(overtimeType === "Regular"){
            if(parseInt(hours) > parseInt(maximumOTHours)){
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage("Hours exceed to its maximum limit.");

                return;
            }
        } */

        handleSubmit(e);
        setErrorState(false);
    };

    const openViewHistoryForm = () => {
        setShowVieHistoryForm(true);
    }
    const closeViewHistoryForm = () => {
        setShowVieHistoryForm(false);
    }

    // for upload
    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);

        /* if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        } */

        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        /* if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        } */

        setFiles(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    // for upload gps cam
    const handleBrowseGPSCam = (e) => {
        const fileList = Array.from(e.target.files);

        /* if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setFiles("");
                return;
            }
        } */

        setGPSCam(fileList);
    };
    const handleDropGPSCam = (e) => {
        e.preventDefault();
        
        const fileList = Array.from(e.dataTransfer.files);
        e.currentTarget.style.backgroundColor = "white";

        /* if (fileList.length > 0) {
            if(!fileList[0].type.startsWith("image/")){
                alert("Please select an image file.");
                setGPSCam("");
                return;
            }
        } */

        setGPSCam(fileList);
    };
    const handleDragOverGPSCam = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOutGPSCam = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFilesGPSCam = () => {
        // Clear the files state
        setGPSCam([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };
    
    //send sms
    const fetchDataApproverById = useCallback(async () => {
        const apiUrl =  domain + "/api/ApproverHierarchy";

        try {
            const response = await axios.get(apiUrl + `/${user.employeePersonalInformationId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);
    const fetchDataEmployeesById = useCallback(async (id) => {
        const apiUrl = domain +"/api/Employee";

        try {
            const response = await axios.get(apiUrl + `/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);
    const getApproverContact = async () =>{
        const formatPhoneNumber = (number) => {
            // Remove all dashes
            const cleanedNumber = number.replace(/-/g, '');
        
            // Check if the number starts with '0' and remove it
            const formattedNumber = cleanedNumber.startsWith('0') 
                ? '+63' + cleanedNumber.slice(1) 
                : '+63' + cleanedNumber;
        
            return formattedNumber;
        };

        const myApprover = await fetchDataApproverById();
        // const employeesInfo = await fetchDataEmployeesById();
        let approverNumbers = [];

        if(myApprover.primaryApprover){
            if(myApprover.primaryApprover.primaryApprover1Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover1Id,
                        fullName: myApprover.primaryApprover.primaryApprover1FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover2Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover2Id,
                        fullName: myApprover.primaryApprover.primaryApprover2FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover3Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover3Id,
                        fullName: myApprover.primaryApprover.primaryApprover3FullName
                    });
                }
            }

            if(myApprover.primaryApprover.primaryApprover4Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.primaryApprover.primaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.primaryApprover.primaryApprover4Id,
                        fullName: myApprover.primaryApprover.primaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.secondaryApprover){
            if(myApprover.secondaryApprover.secondaryApprover1Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover1Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover1FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover2Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover2Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover2FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover3Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover3Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover3FullName
                    });
                }
            }

            if(myApprover.secondaryApprover.secondaryApprover4Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.secondaryApprover.secondaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.secondaryApprover.secondaryApprover4Id,
                        fullName: myApprover.secondaryApprover.secondaryApprover4FullName
                    });
                }
            }
        }

        if(myApprover.tertiaryApprover){
            if(myApprover.tertiaryApprover.tertiaryApprover1Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover1Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover1Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover1FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover2Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover2Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover2Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover2FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover3Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover3Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover3Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover3FullName
                    });
                }
            }

            if(myApprover.tertiaryApprover.tertiaryApprover4Id){
                const foundndInfo = await fetchDataEmployeesById(myApprover.tertiaryApprover.tertiaryApprover4Id);

                if(foundndInfo && foundndInfo.mobileNumber){
                    approverNumbers.push({
                        phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber), 
                        id: myApprover.tertiaryApprover.tertiaryApprover4Id,
                        fullName: myApprover.tertiaryApprover.tertiaryApprover4FullName
                    });
                }
            }
        }

        return approverNumbers;
    }
    const sendSms = async (data) => {
        const formattedNumber = data.referenceNumber.toString().padStart(6, '0');
        const contacts = await getApproverContact();

        if(contacts.length <= 0){
            return;
        }

const composeMessage = 
`Hello,

${employee} filed an Overtime Request. 

Please check reference number OT-${formattedNumber} in the portal.`
;
        
        for (const contact of contacts) {
            const smsData = {
                requestTypeId: 3,
                date: new Date(),
                senderId: user.employeePersonalInformationId,
                senderFullName: user.employeePersonalInformationFullName,
                message: composeMessage,
                recipientId: contact.id,
                recipientFullName: contact.fullName,
                recipientMobileNumber: contact.phoneNumber // phoneNumber
            }

            try {
                const response = await axios.post('http://161.49.93.114:8081/api/Sms/send-sms', smsData); // euro asia
                // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms', smsData); // my server
                console.log(response, `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
            } catch (error) {
                console.error(`Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`, error);
                console.log(`Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
            }
        }
    };
    const sendSmsTrial = async () => {
        const smsData = {
            requestTypeId: 1,
            date: new Date(),
            senderId: 3151,
            senderFullName: "Calingasan, JV",
            message: "TEST",
            recipientId: 3078,
            recipientFullName: "santos, immanuel",
            recipientMobileNumber: "+639067985609" // phoneNumber
        }

        try {
            setLoadingRequest(true);
            // const response = await axios.post('http://161.49.93.114:8081/api/Sms/send-sms', smsData); // euro asia
            const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms', smsData); // my server
            console.log(response, `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
        } catch (error) {
            console.error(`Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`, error);
            console.log(`Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`);
        }
        
        setLoadingRequest(false);
    };

    let testSMS = false;

    const numberWithCommasAndDecimal = (number) => {
        if (!number) {
            return "0.00";
        }
        return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                <div className="TransactionInfo Transaction-Form-Info">
                        <div className="transaction-header">
                            <div className='sub-title row'>
                                    <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                    <span style={{borderBottom:"1px solid black"}}>{"Overtime"}</span>
                            </div>
                            <div className='row' style={{alignItems:"center", justifyContent:"space-between"}}>
                                <h3>Overtime</h3>
                                <div className="transaction-form-upper row" style={{display: "none"}}>
                                    {CreateButton("overtime-add-button", "upload row", (e)=>setShowUploadForm(true), "UPLOAD", UploadIcon)}
                                    {CreateButton("overtime-add-button", "viewHistory row", openViewHistoryForm, "VIEW HISTORY", RemoveRedEyeIcon)}
                                </div>
                                <div className="transaction-form-upper row">
                                    { testSMS &&
                                        <>
                                        {CreateButton("overtime-add-button", "viewHistory row", sendSmsTrial, "SEND SMS", RemoveRedEyeIcon)}
                                        </>
                                    }
                                    {CreateButton("overtime-add-button", "viewHistory row", openViewHistoryForm, "VIEW HISTORY", RemoveRedEyeIcon)}
                                </div>
                            </div>
                        </div>
                        <div className="transaction-body">
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Employee</h4></div>
                                        <div className="transaction-form-input">
                                            <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                                <input
                                                    readOnly
                                                    className='employeeInput-select'
                                                    placeholder="Employee"
                                                    value={employee ? (employee) : employee}
                                                />
                                                <button
                                                    className="select row"
                                                    onClick={() => setShowEmployeeForm(true)}
                                                    style={{
                                                        visibility:
                                                        userAccess.description === "Admin" ||
                                                        userAccess.description === "HR Head" ||
                                                        userAccess.description === "HR Assistant" ||
                                                        userAccess.description === "HR Assistant2" ||
                                                        userAccess.description === "HR Assistant3" ||
                                                        userAccess.description === "HR Manager"
                                                            ? "visible"
                                                            : "hidden",
                                                    }}
                                                    >
                                                    <SearchIcon />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !employee && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Overtime Type</h4></div>
                                        <div className="transaction-form-input">
                                            <OvertimeTypeSelect overtimeType={overtimeType} setOvertimeType={setOvertimeType}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !overtimeType && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Date</h4></div>
                                        <div className="transaction-form-input">
                                            <DateTimeInput date={date} setDate={setDate}/>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !date && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Hours</h4></div>
                                        <div className="transaction-form-input info-item">
                                            <input
                                                type='number'
                                                id="hours"
                                                placeholder="Hours"
                                                value={hours}
                                                onChange={(e) => setHours(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {overtimeType === "Regular" && (
                                        <span
                                        style={{
                                            marginTop: "-10px",
                                            display: "flex",
                                            justifyContent: "center",
                                            visibility: date ? "visible" : "hidden",
                                            color: "green",
                                            fontSize: "12px",
                                        }}
                                        >
                                        {`Maximum hours: ${
                                            dtrData.length > 0
                                            ? numberWithCommasAndDecimal(dtrData[0].otHours)
                                            : "0.00"
                                        }`}
                                        </span>
                                    )}
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !hours && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                    {/* { overtimeType === "Regular" && <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: date ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>{`Maximum OT hours is ${maximumOTHours}`}
                                    </span>} */}
                                </div>
                            </div>
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%", display: "none"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-input" style={{width:"auto"}}>
                                            <input 
                                                type="checkbox" 
                                                id="overtime-allowance" 
                                                className="checkbox" 
                                                name="" 
                                                checked={hasOvertimeAllowance}
                                                onChange={(e) => setHasOvertimeAllowance(e.target.checked)}
                                            />
                                        </div>
                                        <div className="transaction-form-category"><h5 style={{fontWeight:"normal"}}>With overtime allowance?</h5></div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='hidden'>
                                    <div className='column' style={{width:"100%"}}>
                                        <div className="transaction-form-item row">
                                            <div className="transaction-form-input" style={{width:"auto"}}>
                                                <input 
                                                    type="checkbox" 
                                                    id="overtime-above2" 
                                                    className="checkbox" 
                                                    name="" 
                                                    checked={isAboveTwoHoursOvertime}
                                                    onChange={(e) => setIsAboveTwoHoursOvertime(e.target.checked)}
                                                />
                                            </div>
                                            <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>Above two hours overtime?</h5></div>
                                        </div>
                                        <span style={{
                                                marginTop:"-10px",
                                                display:"flex",
                                                justifyContent:"center",
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                    </div>
                                    <div className='column' style={{width:"100%"}}>
                                        <div className="transaction-form-item row">
                                            <div className="transaction-form-input" style={{width:"auto"}}>
                                                <input 
                                                    type="checkbox" 
                                                    id="overtime-above2" 
                                                    className="checkbox" 
                                                    name="" 
                                                    checked={isOTStraightWithoutBreak}
                                                    onChange={(e) => setIsOTStraightWithoutBreak(e.target.checked)}
                                                />
                                            </div>
                                            <div className="transaction-form-category" style={{padding:"0 10px"}}><h5 style={{fontWeight:"normal"}}>OT straight without break?</h5></div>
                                        </div>
                                        <span style={{
                                                marginTop:"-10px",
                                                display:"flex",
                                                justifyContent:"center",
                                                visibility: "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                    <div className="transaction-form-category"><h4 style={{margin:'0'}}>Reason</h4></div>
                                    <div className="transaction-form-input">
                                        <textarea id="overtime-tamper"
                                            style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                            value={reason}
                                            onChange={(e) => setReason(e.target.value)}
                                        />
                                    </div>
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                <div className="transaction-form-category"><h4 style={{margin:'0'}}>GPS Cam Attachment</h4></div>
                                <div className="transaction-form-input">
                                    <label htmlFor="fileInputGPSCam" className='browse'>Browse...</label>
                                    <input
                                        type="file"
                                        id="fileInputGPSCam"
                                        onChange={(e)=> handleBrowseGPSCam(e)}
                                        style={{ display: 'none' }}
                                    />
                                    
                                    {gpsCam.length > 0 ? (
                                        <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                            <span>Uploaded File:</span>
                                            <ul>
                                                {gpsCam.map((file, index) => (
                                                <span key={index}>{file.name}</span>
                                                ))}
                                            </ul>
                                            <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                                <button id="add-family" 
                                                className="cancel row"
                                                onClick={()=>clearFilesGPSCam()}
                                                style={{marginRight:"5px"}}>
                                                    CLEAR
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div
                                            id='drop-files-here'
                                            onDrop={(e)=>handleDropGPSCam(e)}
                                            onDragOver={(e)=>handleDragOverGPSCam(e)}
                                            onDragLeave={(e)=>handleDragOutGPSCam(e)}
                                            style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '5px',
                                            padding: '20px',
                                            marginTop: '10px',
                                            textAlign: 'center',
                                            }}
                                        >
                                            Drop files here
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
                                <div className="transaction-form-category"><h4 style={{margin:'0'}}>Attached Proof of Approval</h4></div>
                                <div className="transaction-form-input">
                                    <label htmlFor="fileInput" className='browse'>Browse...</label>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        onChange={(e)=> handleBrowse(e)}
                                        style={{ display: 'none' }}
                                    />
                                    
                                    {files.length > 0 ? (
                                        <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                            <span>Uploaded File:</span>
                                            <ul>
                                                {files.map((file, index) => (
                                                <span key={index}>{file.name}</span>
                                                ))}
                                            </ul>
                                            <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                                <button id="add-family" 
                                                className="cancel row"
                                                onClick={()=>clearFiles()}
                                                style={{marginRight:"5px"}}>
                                                    CLEAR
                                                </button>
                                            </div>
                                        </div>
                                    )
                                    :
                                    (
                                        <div
                                            id='drop-files-here'
                                            onDrop={(e)=>handleDrop(e)}
                                            onDragOver={(e)=>handleDragOver(e)}
                                            onDragLeave={(e)=>handleDragOut(e)}
                                            style={{
                                            border: '2px dashed #ccc',
                                            borderRadius: '5px',
                                            padding: '20px',
                                            marginTop: '10px',
                                            textAlign: 'center',
                                            }}
                                        >
                                            Drop files here
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="transaction-form-footer">
                                {CreateButton("overtime-add-button", "submit", (e)=>submit(e), "SEND REQUEST", "")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    handleFileUpload={handleFileUpload}
            >
            </UploadForm>
            <ViewHistoryForm  isOpen={showVieHistoryForm} 
                    onClose={closeViewHistoryForm}
                    user={user}
            >
            </ViewHistoryForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeeId}
                    setEmployee={setEmployee}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function OvertimeTypeSelect({overtimeType, setOvertimeType}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setOvertimeType(event.target.value);
    };

    useEffect(() => {
        if(overtimeType !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [overtimeType]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={overtimeType} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose overtime type</option>
            <option value="Regular">Regular</option>
            {/* <option value="RestdaySaturday">Restday Saturday</option>
            <option value="RestdaySunday">Restday Sunday</option>
            <option value="SpecialHoliday">Special Holiday</option>
            <option value="RegularHoliday">Regular Holiday</option>
            <option value="RestdaySpecialHoliday">Restday Special Holiday</option>
            <option value="RestdayRegularHoliday">Restday Regular Holiday</option> */}
            </select>
        </div>
    );
};
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date.slice(0, 16)} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function UploadForm({isOpen, 
    onClose,
    handleFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
    };

    const [files, setFiles] = useState([]);

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
    };

    const submit = (e) =>{
        handleFileUpload(files);
        handleClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>
                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                            <button id="add-family" 
                                className="save row"
                                onClick={(e)=>submit(e)}
                                style={{marginRight:"5px"}}>
                                    UPLOAD
                            </button>
                            <button id="add-family" 
                                className="cancel row"
                                onClick={()=>handleClose()}>
                                    CANCEL
                            </button>
                        </div>)
                    }
                </div>
            )}
            </div>
        </>
    );
} 
function ViewHistoryForm({isOpen, 
    onClose,
    user
}){
    var header = [
        "Reference No.",
        "Date",
        "Overtime Type",
        "Hours",
        "Reason",
        "Proof of Approval",
        "GPS Cam",
        "Status",
    ]
    var accessor = [
        "referenceNumber",
        "date",
        "overtimeType",
        "hours",
        "reason",
        "content",
        "gpsCam",
        "status",
    ]

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/OvertimeRequest";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}/employee/${user.employeePersonalInformationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            setRequests(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen]);

    const handleClose = () => {
        onClose();
    };

    const fetchDataById = useCallback(async (_data) => {
        const apiUrl =  domain + "/api/OvertimeRequest";

        try {
            const response = await axios.get(`${apiUrl}/${_data.id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return (response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return null
        }
    }, []);

    const [attachmentType, setAttachmentType] = useState(null)
    const [selectedData, setSelectedData] = useState(null)
    const [showViewForm, setShowViewForm] = useState(false)

    const openViewForm = () => {
        setShowViewForm(true)
    }
    const closeViewForm = () => {
        setShowViewForm(false)
    }

    const viewHandleClick = async (_data, _type) => {
        setLoading(true)

        const fetched = await fetchDataById(_data)
        setSelectedData(fetched)
        setAttachmentType(_type)

        openViewForm();
        setLoading(false)
    }

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Overtime Filed History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                viewHandleClick={viewHandleClick}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>

            <AttachmentForm 
                isOpen={showViewForm}
                onClose={closeViewForm}
                modalName={attachmentType}
                data={attachmentType === "Proof of Approval" ? (selectedData?.content || null) : attachmentType === "GPS Cam" ? (selectedData?.gpsCam || null) : null}
            />
        </>
    );
}

function AttachmentForm({
    isOpen,
    onClose,
    modalName,
    data
}) {

    const handleClose = () => {
        onClose();
    };

    const base64Data = data;

    // Detect file type from Base64 signature
    const getMimeType = (base64) => {
        if (!base64) return null;

        if (base64.startsWith("/9j/")) {
            return "image/jpeg";
        }

        if (base64.startsWith("iVBORw0KGgo")) {
            return "image/png";
        }

        if (base64.startsWith("R0lGOD")) {
            return "image/gif";
        }

        if (base64.startsWith("JVBERi0")) {
            return "application/pdf";
        }

        // Excel XLSX / DOCX / other Office files
        if (base64.startsWith("UEsDB")) {
            return "application/zip";
        }

        return "application/octet-stream";
    };

    const mimeType = getMimeType(base64Data);

    const fileUrl = base64Data
        ? `data:${mimeType};base64,${base64Data}`
        : null;

    const isImage = mimeType?.startsWith("image/");
    const isPdf = mimeType === "application/pdf";

    const downloadFile = () => {
        if (!fileUrl) return;

        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "attachment";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
                {isOpen && (
                    <div className="modal">

                        {/* HEADER */}
                        <div className="popUp-header row">
                            <div className="popUp-title">
                                <h3 style={{ color: "#668fca" }}>
                                    {modalName}
                                </h3>
                            </div>

                            <div className="popUp-close">
                                <CloseIcon onClick={handleClose} />
                            </div>
                        </div>


                        {/* BODY */}
                        <div className="popUp-body loan-history-table user-template-body">

                            <div className="flex flex-col items-center justify-center w-full min-h-[400px] p-6">

                                {!base64Data && (
                                    <div className="text-gray-500">
                                        No attachment available.
                                    </div>
                                )}


                                {/* IMAGE */}
                                {isImage && fileUrl && (
                                    <div className="flex items-center justify-center w-full">

                                        <img
                                            src={fileUrl}
                                            alt="Attachment"
                                            className="max-w-full max-h-[600px] object-contain rounded-lg shadow"
                                        />

                                    </div>
                                )}


                                {/* PDF */}
                                {isPdf && fileUrl && (
                                    <iframe
                                        src={fileUrl}
                                        title="PDF Attachment"
                                        className="w-full h-[600px] border rounded-lg"
                                    />
                                )}


                                {/* OTHER FILES */}
                                {base64Data && !isImage && !isPdf && (
                                    <div className="flex flex-col items-center justify-center text-center">

                                        <div className="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mb-4">
                                            <span className="text-4xl">
                                                📄
                                            </span>
                                        </div>

                                        <h4 className="text-lg font-semibold text-gray-700 mb-4">
                                            Attachment
                                        </h4>

                                        <button
                                            type="button"
                                            onClick={downloadFile}
                                            className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                                        >
                                            Download File
                                        </button>

                                    </div>
                                )}

                            </div>

                        </div>


                        {/* FOOTER */}
                        <div
                            className="buttons row"
                            style={{
                                justifyContent: "center",
                                padding: "40px 40px 20px 40px"
                            }}
                        >
                        </div>

                    </div>
                )}
            </div>
        </>
    );
}


export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick, viewHandleClick }) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    return (
        <>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {
                                    column.render("Header")
                                    }
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick,
                                            viewHandleClick
                                        )
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick, viewHandleClick) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }
    
    if(header === "Proof of Approval"
        || header === "GPS Cam"
        || header === "Medical Certificate"
    ) {
        return(
            <td>
                <Tooltip text="View">
                    <div style={{padding:"0 5px"}} onClick={()=>viewHandleClick(data, header)}><RemoveRedEyeIcon/></div>
                </Tooltip>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.content){
            const imageSrc = 'data:image/jpeg;base64,' + data.content;

            return(
                <td>
                    <img className="" src={imageSrc} alt="" style={{width: "250px", height: "auto"}}/>
                </td>
            )
        }
        return(
            <td>
                <img className="" src="" alt=""/>
            </td>
        )
    }

    if(header === "Reference No."){
        const formattedNumber = value.toString().padStart(6, '0');

        if(data.requestTypeId === 1){
            return (
                <td>
                    LV-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 2){
            return (
                <td>
                    CS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 3){
            return (
                <td>
                    OT-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 4){
            return (
                <td>
                    CH-{formattedNumber}
                </td>
            );
        }  else if(data.requestTypeId === 5){
            return (
                <td>
                    OS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 6){
            return (
                <td>
                    OB-{formattedNumber}
                </td>
            );
        } 
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Has Allowance" || header === "Is Above 2 Hours"){
        return (
            <td>
                {value.toString()}
            </td>
        );
        
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        const time = _cell.render("Cell").props.value;
        if(!time) {
            return (
                <td>
                    null
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
export default Overtime
